const SET_SETTINGS = 'SET_SETTINGS';

export { SET_SETTINGS };
